<template>
  <div>
    <div class="form-row">
      <template v-if="showSplitName">
        <SplitNameFormPart v-on="$listeners" />
      </template>
      <template v-else>
        <NameField
          :label="$t('field.name.label')"
          placeholder=""
          v-on="$listeners"
        />
      </template>
    </div>

    <div class="form-row border-t-0">
      <PhoneField
        :label="$t('field.phone.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>

    <div class="form-row">
      <EmailField
        :label="$t('field.email.label')"
        placeholder=""
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import NameField from 'chimera/all/components/form/fields/name/NameField'
import EmailField from 'chimera/all/components/form/fields/email/EmailField'
import PhoneField from 'chimera/all/components/form/fields/phone/PhoneField'
import SplitNameFormPart from 'chimera/all/components/form/parts/SplitNameFormPart.vue'

export default {
  name: 'ContactInformationFormPart',

  components: {
    SplitNameFormPart,
    NameField,
    EmailField,
    PhoneField,
  },

  /**
   * @returns {{showSplitName: boolean}}
   */
  data() {
    return {
      showSplitName: undefined,
    }
  },

  /**
   *
   */
  beforeMount() {
    this.showSplitName =
      process.env.concept?.toLowerCase() !== 'comparamudanzas.es'
  },
}
</script>
